import { render, staticRenderFns } from "./RsvpPagePreviewBanner.vue?vue&type=template&id=1c0a16a4"
import script from "./RsvpPagePreviewBanner.vue?vue&type=script&lang=js"
export * from "./RsvpPagePreviewBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports